import React from 'react'

export default function Loading() {
  return (
    <div>
      <img src='https://www.royalmint.com/globalassets/bullion/_new_structure/coins/silver/ukbsb221c-obverse.png' alt='logo-loading' className='logo-loading' />
    </div>
  )
}
